export default import.meta.ROLLUP_FILE_URL_noE9t7yRNJd$tXdw5W2Nww